import { addDoc, collection, getDocs, limit, orderBy, query } from "firebase/firestore";
import { db } from "../../../firebase";
import { AUDIT_COLLECTION } from "../constants";
import { serializeValue } from "../utils/firestoreValueUtils";

export async function writeAuditLog({
  adminName,
  adminUid,
  action,
  collection: col,
  documentIds = [],
  oldValues,
  newValues,
}) {
  await addDoc(collection(db, AUDIT_COLLECTION), {
    adminName,
    adminUid,
    action,
    collection: col,
    documentIds,
    oldValues: serializeValue(oldValues),
    newValues: serializeValue(newValues),
    dateTime: new Date().toISOString(),
    device: typeof navigator !== "undefined" ? navigator.userAgent : "",
  });
}

export async function fetchAuditLogs({ action, collection: col, days = 7, max = 200 } = {}) {
  const since = new Date(Date.now() - days * 24 * 60 * 60 * 1000).toISOString();
  const snap = await getDocs(
    query(collection(db, AUDIT_COLLECTION), orderBy("dateTime", "desc"), limit(max))
  );
  let rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  rows = rows.filter((r) => r.dateTime >= since);
  if (action) rows = rows.filter((r) => r.action === action);
  if (col) rows = rows.filter((r) => r.collection === col);
  return rows;
}

export async function todayStats(adminUid) {
  const start = new Date();
  start.setHours(0, 0, 0, 0);
  const since = start.toISOString();
  const snap = await getDocs(
    query(collection(db, AUDIT_COLLECTION), orderBy("dateTime", "desc"), limit(500))
  );
  let updates = 0;
  let deletes = 0;
  snap.docs.forEach((d) => {
    const data = d.data();
    if (data.dateTime < since) return;
    if (adminUid && data.adminUid !== adminUid) return;
    if (String(data.action || "").includes("delete")) deletes += 1;
    else if (String(data.action || "").includes("update") || String(data.action || "").includes("bulk")) updates += 1;
  });
  return { updates, deletes };
}
